import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import { useLanguage } from '../../../hooks/useLanguage';
import StyledButton from '../../Buttons/StyledButton';
import StyledCol from '../../Cols/StyledCol';
import { StyledModal } from '../StyledModal/StyledModal';

interface IDeleteResourceModal {
    show: boolean;
    resourceName: string;
    onHide: () => void;
    onSubmit: () => void;
}

const DeleteResourceModal = (props: IDeleteResourceModal) => {
    const { t } = useLanguage();

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();

        props.onSubmit();
    };

    return (
        <StyledModal
            show={props.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">Löschen</Modal.Title>
            </Modal.Header>
            <Form className="m-3" noValidate onSubmit={handleSubmit}>
                <Container fluid>
                    <div>
                        <Modal.Body>
                            <Row style={{ padding: 10 }}>
                                <Col>
                                    <p>
                                        Sind Sie sicher, dass Sie <b>{props.resourceName}</b> löschen wollen?
                                    </p>
                                </Col>
                            </Row>
                            <div>
                                <div style={{ float: 'left' }}>
                                    <StyledCol textAlign="left">
                                        <StyledButton variant="secondary" onClick={props.onHide}>
                                            {t('BUTTONS', 'Abbrechen')}
                                        </StyledButton>
                                    </StyledCol>
                                </div>
                                <div style={{ float: 'right' }}>
                                    <StyledCol paddingLeft="30px">
                                        <StyledButton type="submit">Löschen</StyledButton>
                                    </StyledCol>
                                </div>
                            </div>
                        </Modal.Body>
                    </div>
                </Container>
            </Form>
        </StyledModal>
    );
};

export default DeleteResourceModal;
